import { HttpClient as THttpClient } from "@data-types/http/HttpClient";
import { mtlsHttpClient } from "./mtlsHttpClient";
import { mainHttpClient } from "@utils/http/mainHttpClient";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";

const defaultConfig = {
	useMtls: isCapacitorPlatform() && WEBPACK_IS_MTLS_ENABLED,
};

class HttpClient {
	private static instance: THttpClient | null = null;
	private static config = defaultConfig;

	static getInstance(): THttpClient {
		if (!this.instance) {
			if (this.config.useMtls) {
				this.instance = mtlsHttpClient;
			} else {
				this.instance = mainHttpClient;
			}
		}
		return this.instance;
	}
}

const httpClient = HttpClient.getInstance();
export { httpClient };
